export const NOTIFICATION_TYPE = {
  FINANCE: {
    key: "FINANCE",
    name: "Finance",
  },
  PARCEL: {
    key: "PARCEL",
    name: "Parcel",
  },
  ANNOUNCEMENT: {
    key: "ANNOUNCEMENT",
    name: "Announcement",
  },
};
